import { useEffect } from 'react';

export function useDocumentMetadata(title: string, description?: string) {
  useEffect(() => {
    document.title = `${title} | Emazy`;

    if (description) {
      let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.append(meta);
      }
      meta.content = description;
    }
  }, [description, title]);
}
